import { SocialAuditStatus } from '../../export-prospect-audit/types'

export const PERFORMANCE_POINTS = [
  {
    label: 'Good points',
    key: SocialAuditStatus.Good,
  },
  {
    label: 'Potential for improvement',
    key: SocialAuditStatus.Warning,
  },
  {
    label: 'Critical errors',
    key: SocialAuditStatus.Critical,
  },
]

export const SOCIAL_LABELS = {
  instagram: 'Instagram',
  tiktok: 'TikTok',
}
